export const estimateForgivenessAmountSelector = (state) => ({
  advance: state.entities.advances.byId[state.activeIds.advanceId],
  loanForgiveness: state.entities.loanForgiveness,
  page2Values: state.form?.forgivenessPage2?.values,
  page5Values: state.form?.forgivenessPage5?.values,
});
